<br/><br/>
<h1>{{ 'pilotageParametres.titre' | translate }}</h1>
<br/>

<!-- FORMULAIRE D'AJOUT / ÉDITION -->
<div class="form-container mb-4">
  <form [formGroup]="formGroup" (ngSubmit)="addOrUpdate()">

    <div class="champ-50 mb-3">
      <label class="form-label" for="parametreCode">
        {{ 'pilotageParametres.grille.parametre' | translate }}
      </label>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select id="parametreCode" formControlName="parametreCode">
          @for (p of parametres; track p.code) {
            <mat-option [value]="p.code">{{ p.code }} — {{ p.description }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (formGroup.controls.parametreCode.touched && formGroup.controls.parametreCode.hasError('required')) {
        <div class="messageerreur">{{ 'pilotageParametres.messages.parametreRequis' | translate }}</div>
      }
    </div>

    <div class="champ-100 mb-3">
      <label class="form-label" for="valeur">
        {{ 'pilotageParametres.grille.valeur' | translate }}
      </label>
      <mat-form-field appearance="outline" class="w-100">
        <textarea matInput id="valeur" rows="3" formControlName="valeur"></textarea>
        @if (longueurMax !== null) {
          <mat-hint align="end">{{ (formGroup.controls.valeur.value ?? '').trim().length }} / {{ longueurMax }}</mat-hint>
        }
      </mat-form-field>
      @if (formGroup.controls.valeur.touched && formGroup.controls.valeur.hasError('required')) {
        <div class="messageerreur">{{ 'pilotageParametres.messages.valeurRequise' | translate }}</div>
      }
      @if (formGroup.controls.valeur.hasError('longueurMax')) {
        <div class="messageerreur">
          {{ 'pilotageParametres.messages.longueurMax' | translate: { max: longueurMax } }}
        </div>
      }
    </div>

    <div class="ligne-date">
      <div class="champ-25 mb-3">
        <label class="form-label" for="dateDebut">
          {{ 'pilotageParametres.grille.dateDebut' | translate }}
        </label>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput id="dateDebut" readonly [matDatepicker]="pickerDebut" formControlName="dateDebut">
          <mat-datepicker-toggle matSuffix [for]="pickerDebut"></mat-datepicker-toggle>
          <mat-datepicker #pickerDebut></mat-datepicker>
        </mat-form-field>
        @if (formGroup.controls.dateDebut.touched && formGroup.controls.dateDebut.hasError('required')) {
          <div class="messageerreur">{{ 'pilotageParametres.messages.dateDebutRequise' | translate }}</div>
        }
      </div>

      <div class="champ-25 mb-3">
        <label class="form-label" for="dateFin">
          {{ 'pilotageParametres.grille.dateFinFacultative' | translate }}
        </label>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput id="dateFin" readonly [matDatepicker]="pickerFin" formControlName="dateFin">
          @if (formGroup.controls.dateFin.value) {
            <button mat-icon-button matSuffix type="button"
              [attr.aria-label]="'pilotageParametres.grille.effacerDateFin' | translate"
              (click)="formGroup.controls.dateFin.setValue(null)">
              <mat-icon>close</mat-icon>
            </button>
          }
          <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
          <mat-datepicker #pickerFin></mat-datepicker>
        </mat-form-field>
        @if (formGroup.hasError('dateInvalide')) {
          <div class="messageerreur">{{ 'pilotageParametres.messages.dateDebutSuperieurFin' | translate }}</div>
        }
      </div>
    </div>

    <div class="buttons-container">
      <button mat-raised-button
        color="secondary"
        type="button"
        class="me-2"
        (click)="clearFormFields()">
        {{ 'sigt.global.boutons.annuler' | translate }}
      </button>
      <button mat-raised-button
        color="primary"
        type="submit"
        [disabled]="formGroup.invalid">
        {{ enEdition === null
          ? ('sigt.global.boutons.ajouter' | translate)
          : ('sigt.global.boutons.enregistrer' | translate)
        }}
      </button>
    </div>

  </form>
</div>

<table mat-table [dataSource]="dataSource" class="table-container mat-elevation-z8">

  <ng-container matColumnDef="parametre">
    <th mat-header-cell *matHeaderCellDef>{{ 'pilotageParametres.grille.parametre' | translate }}</th>
    <td mat-cell *matCellDef="let row">
      {{ row.parametreCode }}<br/>
      <span class="description">{{ row.description }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="valeur">
    <th mat-header-cell *matHeaderCellDef>{{ 'pilotageParametres.grille.valeur' | translate }}</th>
    <td mat-cell *matCellDef="let row" class="cellule-valeur">{{ row.valeur }}</td>
  </ng-container>

  <ng-container matColumnDef="dateDebut">
    <th mat-header-cell *matHeaderCellDef>{{ 'pilotageParametres.grille.dateDebut' | translate }}</th>
    <td mat-cell *matCellDef="let row">{{ row.dateDebutEffective | date:'dd MMM yyyy' }}</td>
  </ng-container>

  <ng-container matColumnDef="dateFin">
    <th mat-header-cell *matHeaderCellDef>{{ 'pilotageParametres.grille.dateFin' | translate }}</th>
    <td mat-cell *matCellDef="let row">{{ (row.dateFinEffective | date:'dd MMM yyyy') ?? '—' }}</td>
  </ng-container>

  <ng-container matColumnDef="statut">
    <th mat-header-cell *matHeaderCellDef>{{ 'pilotageParametres.grille.statut' | translate }}</th>
    <td mat-cell *matCellDef="let row">{{ 'pilotageParametres.statuts.' + row.statut | translate }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>{{ 'pilotageParametres.grille.actions' | translate }}</th>
    <td mat-cell *matCellDef="let row">
      <button
        mat-icon-button
        matTooltip="{{ 'pilotageParametres.grille.tooltipBoutonModifier' | translate }}"
        (click)="startEdit(row)">
        <mat-icon>edit</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="table-header"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<mat-paginator
  [pageSize]="10"
  [pageSizeOptions]="[5,10,20]"
  showFirstLastButtons>
</mat-paginator>
